import { defineEnvSchema, makeBooleanVar, makeNumberVar, makeStringVar } from '@pickleballinc/lib/env';

export const systemEnvSchema = defineEnvSchema({
	DOCKER_BUILD: makeBooleanVar({ required: false, default: false }),
	DEBUG_ENV_VAR: makeBooleanVar({ required: false, default: false }),
	BUILD_ID: makeStringVar({ required: true, minLength: 20 }),
	NODE_ENV: makeStringVar({ required: true, choices: ['development', 'production', 'test'] }),
	NEXT_RUNTIME: makeStringVar({ required: false, choices: ['nodejs', 'edge'], default: 'nodejs' })
});

export const publicEnvSchema = defineEnvSchema({
	NEXT_PUBLIC_API_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_API_URL_V2: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_APP_ENV: makeStringVar({ required: true, choices: ['dev', 'prod', 'test'], default: 'dev' }),
	NEXT_PUBLIC_RTE_ENABLED: makeBooleanVar({ required: false, default: true }),
	NEXT_PUBLIC_IMAGE_CDN_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_HOME_ROOT_URL: makeStringVar({ required: true, minLength: 9 }),
	NEXT_PUBLIC_HOME_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_PT_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_PL_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_PC_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_PTL_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_APR_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_GM_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_SSO_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_PBRACKETS_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_PTL_BRACKETS_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_CONTACT_FORM_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_MANAGE_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_CHECKOUT_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_PTL_CHECKOUT_URL: makeStringVar({ required: true, match: 'url' }),
	NEXT_PUBLIC_GOOGLE_MAP_KEY: makeStringVar({ required: true, default: '' }),
	NEXT_PUBLIC_SENTRY_DSN: makeStringVar({ required: false, match: 'url' }),
	NEXT_PUBLIC_IMAGE_UPLOAD_URL: makeStringVar({ required: true, match: 'url' })
});

export const serverEnvSchema = defineEnvSchema({
	API_KEY: makeStringVar({ required: true, mask: true, match: 'uuid' }),
	// Local `/login` only (`@pickleballinc/lib/session/local-login`): set it in your own .env, it
	// is not in Vault. Server-only, never NEXT_PUBLIC_.
	SSO_HEADLESS_API_KEY: makeStringVar({ required: false, mask: true }),
	SENTRY_DEBUG: makeBooleanVar({ required: false, default: false }),
	SENTRY_SAMPLE_RATE: makeNumberVar({ required: false, default: 1.0 }),
	SENTRY_TRACES_SAMPLE_RATE: makeNumberVar({ required: false, default: 1.0 })
});
